module.exports = "<h2 style=\"text-align: center;\">Loading...</h2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/lxp-product-landing/lxp-product-landing.component.html
// module id = 947
// module chunks = 0